import { Injectable, WritableSignal, signal, inject } from '@angular/core';

import { Globals } from '@core/globals';
import { RoutingData } from '@core/routing-data';
import { SsrService } from '@services/ssr.service';
import { RoutingRoute, RoutingNavigationItem, RoutingPages } from '@models/routing.model';
import { Language } from '@models/language.model';

@Injectable({
  providedIn: 'root',
})
export class RoutingService {
  private globals = inject(Globals);
  private ssrService = inject(SsrService);
  public navigation: WritableSignal<RoutingNavigationItem[]> = signal([]);
  public navigationLogged: WritableSignal<RoutingNavigationItem[]> = signal([]);

  setRoutes(language: Language): void {
    const routes: RoutingRoute = {};
    const navigation: RoutingNavigationItem[] = [];
    const navigationLogged: RoutingNavigationItem[] = [];
    for (const page of RoutingData.pages) {
      const url = '/' + page.url[language];
      const route: string = url.split('/:')[0];
      const pageName: string = page.name?.[language] ?? '';
      routes[page.id] = { id: page.id, title: pageName ?? '', url: route, pageType: page.pageType ?? RoutingData.pageTypeDefault, landingpageId: page.landingpageId };
      if (page.menu) navigation.push({ id: page.id, title: pageName ?? '', link: url, icon: page.icon });
      if (page.loggedMenu) navigationLogged.push({ id: page.id, title: pageName, link: url, icon: page.icon });
    }
    this.navigation.set(navigation);
    this.navigationLogged.set(navigationLogged);
    this.globals.routes.set(routes);
  }

  getActivePage(language: Language): { id: string; numberOfParams: number } {
    const index: number = 1;
    const path: string[] = this.ssrService.getLocation().pathname.split('/');
    const url: string = path[index];
    const page: RoutingPages | undefined = RoutingData.pages.find((page) => page.url[language] === url);
    return { id: page?.id ?? '', numberOfParams: path.length - index - 1 };
  }
}
